import Env from '@lib/Env';
import { Actor } from '@types';

export class VideoGalleryModel implements Actor.VideoGallery {
    id: number = null;
    file_id: string = null;
    name: string = null;
    poradie: number = null;
    url: string = null;

    constructor({ id, file_id, name, poradie }: Actor.VideoGallery) {
        this.id = id;
        this.file_id = file_id;
        this.url = `${Env.services.storage.baseURL}/${file_id}`;
        this.name = name;
        this.poradie = poradie;
    }
}
